import React from 'react';
import CountUp from 'react-countup';
import equal from 'fast-deep-equal/es6/react';
import { IIncidentStatus } from '../../../../../core/interfaces/IIncidents';
import { MetricDataSet } from './MetricsDisplay';

interface StatusTabsProps {
  selectedStatus: IIncidentStatus[];
  allStatus: IIncidentStatus[];
  currentDataSet: MetricDataSet;
  previousDataSet?: any;
  onStatusChange: (status: IIncidentStatus[]) => void;
}

const StatusTabs: React.FC<StatusTabsProps> = ({
  selectedStatus,
  allStatus,
  currentDataSet,
  previousDataSet,
  onStatusChange,
}) => {
  return (
    <div className="float-right">
      <div
        className="metric-tab no-select cursor-pointer"
        onClick={() => onStatusChange(allStatus)}
        style={equal(selectedStatus, allStatus) ? { borderBottom: '1px solid #0f61dd' } : {}}
      >
        <p
          className="item-box-tagline"
          style={{
            margin: 0,
            fontWeight: 600,
            textTransform: 'capitalize',
            marginBottom: 8,
            color: equal(selectedStatus, allStatus) ? '#0f61dd' : '#b6bcc8',
          }}
        >
          All
        </p>
        <div
          className="item-box-secondary-heading font-bold"
          style={{
            fontWeight: 600,
            color: equal(selectedStatus, allStatus) ? '#0f61dd' : '#b6bcc8',
            fontSize: 20,
            margin: 0,
          }}
        >
          <CountUp
            preserveValue={true}
            duration={0.8}
            start={
              previousDataSet
                ? previousDataSet.triggered.current +
                  previousDataSet.acknowledged.current +
                  previousDataSet.resolved.current +
                  previousDataSet.suppressed.current
                : null
            }
            end={
              currentDataSet.triggered.current +
              currentDataSet.acknowledged.current +
              currentDataSet.resolved.current +
              currentDataSet.suppressed.current
            }
          />
        </div>
      </div>
      {Object.keys(currentDataSet)
        .slice(0, 4)
        .map((key, index) => {
          return (
            <div
              className="metric-tab no-select cursor-pointer"
              onClick={() => onStatusChange([key as IIncidentStatus])}
              key={index}
              style={equal(selectedStatus, [key]) ? { borderBottom: '1px solid #0f61dd' } : {}}
            >
              <p
                className="item-box-tagline"
                style={{
                  margin: 0,
                  fontWeight: 600,
                  textTransform: 'capitalize',
                  marginBottom: 8,
                  color: equal(selectedStatus, [key]) ? '#0f61dd' : '#b6bcc8',
                }}
              >
                {key}
              </p>
              <div
                className="item-box-secondary-heading font-bold"
                style={{
                  fontWeight: 600,
                  color: equal(selectedStatus, [key]) ? '#0f61dd' : '#b6bcc8',
                  fontSize: 20,
                  margin: 0,
                }}
              >
                <CountUp
                  preserveValue={true}
                  duration={0.8}
                  start={previousDataSet ? (previousDataSet as any)[key].current : null}
                  end={(currentDataSet as any)[key].current}
                />
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default StatusTabs;
